export default __webpack_public_path__ + "static/media/san-rafael-1.bd5528a8.jpg";